<template>
  <div>
    <vxe-grid
      size="small"
      border
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      row-id="orderTechPricingCode"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @cell-click="onCellClick"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
      ref="table"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="
                  opt.disabled == undefined ? false : opt.disabled(row)
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:status="{ row }">
        <div class="status-tag">
          <el-tag effect="dark" size="mini" :type="row.status">
            {{ row.v_status }}
          </el-tag>
        </div>
      </template>
      <template v-slot:displayCreate="{ row }">
        <div>{{ row.createByName }}</div>
        <div>{{ row.createTime }}</div>
      </template>
      <template v-slot:displayModify="{ row }">
        <div>{{ row.modifyByName }}</div>
        <div>{{ row.modifyTime }}</div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import { format } from '@/libs/util.number.js'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (number) => format(number),
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    onCheckboxChange({ records, reserves }) {
      this.$emit('checkboxChange', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkboxChange', [])
    },
    // 避免点击操作列也会选择行
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = [
        'checkbox',
        'defaultImageUrl',
        'col-opt',
        'amzFtyNoticeOutStatus',
      ]
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)
      const data = $table.getCheckboxRecords(true) || []
      const reserves = $table.getCheckboxReserveRecords(true) || []
      this.$emit('checkboxChange', data.concat(reserves))
    },
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { orderTechPricingCode, orderTechPricingNo } = data
      switch (menuType) {
        case 'detail':
        case 'edit':
        case 'auditEdit':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { code: orderTechPricingCode },
            query: { orderTechPricingNo },
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'audit':
          this.audit(data)
          break
        case 'copy':
          this.copy(data)
          break
        case 'export':
          this.$emit('export', data, opt.data)
          break
      }
    },
    async del({ orderTechPricingCode }) {
      if (this.loadingOpen()) return
      const checkRes = await this.$api
        .orderTechPricingDelCheckApi({ orderTechPricingCode })
        .catch(() => null)
      this.loadingClose()

      const { status, msg } = checkRes || {}
      if (203 === status) {
        this.$message.error(msg)
        return
      }
      if (200 !== status) return

      const confirm = await this.$confirm(
        msg,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .orderTechPricingDelApi({ orderTechPricingCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status: deleteStatus } = res
      if (deleteStatus !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async audit({ orderTechPricingCode }) {
      const confirm = await this.$confirm(
        this.$l('label_audit') || '是否审核确认该工价单？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .orderTechPricingAuditApi({ orderTechPricingCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error('审核确认失败！')
        return
      }
      this.$message({
        message: '审核确认成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async copy({ orderTechPricingCode }) {
      const confirm = await this.$confirm(
        this.$l('label_copy') || '是否复制该工价单？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .orderTechPricingCopyApi({ orderTechPricingCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, body } = res
      if (status !== 200) {
        this.$message.error('复制失败！')
        return
      }
      this.$emit('reload')
      const copyConfirm = await this.$confirm(
        this.$l('label_copy_success') || '复制成功，是否跳转到该工价单？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!copyConfirm) return
      const { orderTechPricingNo } = body
      this.$emit('openEditPage', {
        pageType: 'edit',
        params: { code: body.orderTechPricingCode },
        query: { orderTechPricingNo },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  font-size: 12px;
  .el-tag--A {
    color: #91939a;
    background-color: #f4f4f5;
    border: #91939a;
  }

  .el-tag--S {
    color: #70ce46;
    background-color: #f6ffed;
    border: #b7eb8f;
  }

  .el-tag--D {
    color: #f74852;
    background-color: #fff1f0;
    border: #ffa39e;
  }
}
</style>
